import React from "react";
import { AlertCircle, CheckCircle2, Clock3, MailCheck, Radio } from "lucide-react";

const STATUS_META = {
  not_monitored: { label: "Sin monitoreo", icon: Radio, classes: "text-white/45 border-white/10" },
  pending: { label: "Pendiente", icon: Clock3, classes: "text-amber-300 border-amber-300/25" },
  sent: { label: "Enviado", icon: CheckCircle2, classes: "text-emerald-300 border-emerald-300/25" },
  failed: { label: "Fallido", icon: AlertCircle, classes: "text-red-300 border-red-300/25" },
};

export const EmailStatusBadge = ({ status = "not_monitored", testId }) => {
  const meta = STATUS_META[status] || STATUS_META.not_monitored;
  const Icon = meta.icon;
  return (
    <span
      className={`inline-flex items-center gap-1.5 border px-2 py-1 text-[10px] uppercase tracking-[0.16em] ${meta.classes}`}
      data-testid={testId}
    >
      <Icon size={12} aria-hidden="true" />
      {meta.label}
    </span>
  );
};

export const EmailMonitor = ({ monitoring }) => {
  if (!monitoring) return null;
  const counts = monitoring.counts || {};

  return (
    <section
      className="mx-6 md:mx-12 mt-8 border-y border-white/10 py-6"
      data-testid="email-monitoring-summary"
    >
      <div className="flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex items-start gap-4">
          <div className={`mt-0.5 p-2 border ${monitoring.enabled ? "border-emerald-300/30 text-emerald-300" : "border-lux/30 text-lux"}`}>
            <MailCheck size={18} aria-hidden="true" />
          </div>
          <div>
            <div className="flex flex-wrap items-center gap-3">
              <h1 className="font-display text-xl">Monitoreo de notificaciones</h1>
              <span
                className={`text-[10px] uppercase tracking-[0.18em] ${monitoring.enabled ? "text-emerald-300" : "text-lux"}`}
                data-testid="email-monitoring-state"
              >
                {monitoring.enabled ? "Activo" : "Preparado"}
              </span>
            </div>
            <p className="mt-1 max-w-2xl text-sm text-white/50" data-testid="email-monitoring-message">
              {monitoring.enabled
                ? `Registrando entregas enviadas desde ${monitoring.sender_email}.`
                : `Se activará automáticamente cuando ${monitoring.required_sender_email} sea el remitente verificado.`}
            </p>
          </div>
        </div>
        <div className="flex flex-wrap gap-x-6 gap-y-2 text-xs uppercase tracking-[0.16em] text-white/45">
          <span data-testid="email-monitoring-sent-count">Enviados <b className="text-white">{counts.sent || 0}</b></span>
          <span data-testid="email-monitoring-pending-count">Pendientes <b className="text-white">{counts.pending || 0}</b></span>
          <span data-testid="email-monitoring-failed-count">Fallidos <b className="text-white">{counts.failed || 0}</b></span>
        </div>
      </div>
    </section>
  );
};